import styled from 'styled-components';
import { Typography, Table } from '@thinknet-gmbh/platform-common-ui';

export const AssignToDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PopoverContentWrapper = styled.div`
  width: 204px;
  word-wrap: break-word;
`;

export const AssignToRow = styled(Typography)`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  height: 100%;
  white-space: nowrap;
`;

export const StyledTasksTable = styled(Table)`
  
  .task-lightYellow {
    background: ${({ theme }) => theme.colors.tone.lightYellow};
  }

  .task-lightGreen {
    background: ${({ theme }) => theme.colors.tone.lightGreen};
  }

  .task-lightRed {
    background: ${({ theme }) => theme.colors.tone.lightRed};
  }
`;
